export default {
	methods: {
		PegarCNPJDaOS(OrdemDeServico) {
			return OrdemDeServico.cnpj.client_data.cnpj;
		},
		CriarObjetoDaEmpresa(CNPJ, OrdemDeServico, acc) {
			let Empresa = acc.find((Empresa) => Empresa.cnpj == CNPJ);
			if (Empresa == null) {
				let accIndexNewEmpresa = acc.length;
				let NewEmpresa = {
					cnpj: OrdemDeServico.cnpj.client_data.cnpj,
					razao: OrdemDeServico.cliente,
					servicos: {},
				};
				acc.push(NewEmpresa);
				return acc[accIndexNewEmpresa];
			} else {
				return Empresa;
			}
		},
		CriarRelacaoComOServico(Servico, Empresa) {
			if (Empresa.servicos[Servico.cod] == undefined) {
				Empresa.servicos[Servico.cod] = {
					cod: Servico.cod,
					name: Servico.servico,
					tarefas: [],
				};
			}
			return Empresa.servicos[Servico.cod];
		},
		CriarRelacaoDasTarefas(Servicos, OrdemDeServico) {
			Servicos.tarefas.push({
				cod: OrdemDeServico.cod,
				titulo: OrdemDeServico.tarefa,
				status: OrdemDeServico.status,
				statusContrato: OrdemDeServico.contrato.status,
				codContrato: OrdemDeServico.contrato.cod,
				forms: OrdemDeServico.forms,
				datas: {
					dComeco: OrdemDeServico.dComeco,
					dTermino: OrdemDeServico.dTermino,
					dCriacao: OrdemDeServico.dCriacao,
					dInicio: OrdemDeServico.dInicio,
					duracao: OrdemDeServico.duracao,
				},
			});
		},
	},
	computed: {
		itens() {
			return this.preRequestData.reduce((acc, OrdemDeServico) => {
				const CNPJ = this.PegarCNPJDaOS(OrdemDeServico);
				let Empresa = this.CriarObjetoDaEmpresa(
					CNPJ,
					OrdemDeServico,
					acc
				);
				let Servicos = this.CriarRelacaoComOServico(
					OrdemDeServico.idServico,
					Empresa
				);
				this.CriarRelacaoDasTarefas(Servicos, OrdemDeServico);
				return acc;
			}, []);
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/order-of-service/components/ModeAgroup/js/AgroupFunctions.mixin.js